import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchKids, getFilteredKids } from "./Kids-list.ducks";
import { getSections } from "./creche/sections.ducks";
import { closeSnackBar, openSnackBar } from "../../../reducers";
import _ from "lodash";
import HeaderKids from "./header-kids";
import ListDisplay from "./list-display";
import CrecheLife from "./creche-life";
import ModalMultiple from "./modals/modal-multiple";
import ModalEnfant from "./modals/modal-enfant";
import { getJournee } from "./fiche-enfant/les-tabs-ducks/Journee.ducks";
import srcAddWhite from "../../../styles/img/add-white.svg";
import srcImgBaby from "../../../styles/img/icon-baby.svg";
import { fetchAgent } from "../../../components/compte/compte.ducks";
import jwt_decode from "jwt-decode";
import queryString from "query-string";
import KidItem from "./kid-item/KidItem";

const AddWhite = () => (
  <object
    data={srcAddWhite}
    type="image/svg+xml"
    style={{ pointerEvents: "none", width: "12px", height: "12px" }}
    className="img-fluid"
  />
);
const IconBaby = () => (
  <object
    data={srcImgBaby}
    style={{ width: "70px", pointerEvents: "none", cursor: "pointer" }}
    type="image/svg+xml"
    className="img-fluid"
  />
);

var divStyleImg = {
  width: "12px",
};

class Kids extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterStatus: "TOUS",
      filterSectionId: null,
      modalMultiple: false,
      modalEnfant: false,
      submitMulti: false,
      kidItem: {},
      dataMulti: {},
      showAlertSnackbars: false,
      tabToUpdate: "",
      isUpdate: false,
      idEvent: null,
      onlyView: false,
      isLoading: true,
      objAbsence: {},
    };
    this.toggleMultiple = this.toggleMultiple.bind(this);
    this.toggleSimple = this.toggleSimple.bind(this);
    this.editEnfant = this.editEnfant.bind(this);
    this.handleFilterButtons = this.handleFilterButtons.bind(this);
    this.handleMultiSubmit = this.handleMultiSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseError = this.handleCloseError.bind(this);
    this.handleCloseSuccess = this.handleCloseSuccess.bind(this);
    this.stopUpdate = this.stopUpdate.bind(this);
    this.stopViewing = this.stopViewing.bind(this);
    this.handleSectionFilter = this.handleSectionFilter.bind(this);
  }
  componentDidMount() {
    this.timerID = setInterval(() => {
      this.props.getFilteredKids(localStorage.getItem("token"));
    }, 120000);
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  componentWillMount() {
    this.props.getFilteredKids(localStorage.getItem("token"));
    this.props.getSections(localStorage.getItem("token"));
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    if (tokenDecoded && process.env.NODE_ENV === "production") {
      this.props.fetchAgent(token, tokenDecoded.AGENT_ID);
    }
    this.setState({ tokenDecoded });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.successMsg !== this.props.successMsg) {
      this.handleClose();
    }
  }
  stopViewing() {
    this.setState({ onlyView: false });
  }
  stopUpdate() {
    this.setState({ isUpdate: false, objAbsence: {} });
  }
  editEnfant(kidItem) {
    this.setState({ kidItem: kidItem, modalEnfant: true });
  }

  handleClose() {
    this.setState({
      modalEnfant: false,
      submitMulti: false,
      isUpdate: false,
      idEvent: null,
      onlyView: false,
    });
  }
  handleCloseError() {
    this.props.closeSnackBar("errorMsg");
    this.setState({
      showAlertSnackbars: false,
    });
  }
  handleCloseSuccess() {
    this.props.closeSnackBar("successMsg");
    this.setState({
      showAlertSnackbars: false,
    });
  }

  toggleSimple(name) {
    this.setState({
      showAlertSnackbars: true,
    });
  }

  handleMultiSubmit(data) {
    this.setState({
      dataMulti: data,
      submitMulti: true,
      modalMultiple: false,
      modalEnfant: true,
    });
  }

  toggleMultiple() {
    this.setState((prevState) => ({
      modalMultiple: !prevState.modalMultiple,
      submitMulti: false,
    }));
  }

  handleFilterButtons = (value) => {
    this.props.getFilteredKids(localStorage.getItem("token"), value);
    this.setState({
      filterStatus: value,
    });
  };

  handleSectionFilter = (sectionId) => {
    this.setState({
      filterSectionId: sectionId,
    });
  };

  getFilteredKidIds() {
    const { kids } = this.props;
    const { filterSectionId } = this.state;

    if (filterSectionId === null || _.isEmpty(kids.ids)) {
      return kids.ids;
    }

    return kids.ids.filter((kidId) => {
      const kid = kids.byId[kidId];
      return kid && kid.sectionId === filterSectionId;
    });
  }

  getVisibleSections() {
    const { sections, compte } = this.props;
    const { tokenDecoded } = this.state;
    if (!sections || sections.length === 0) return sections;
    if (tokenDecoded && tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE") return sections;
    const agentData = compte && compte.data;
    if (!agentData) return sections;
    if (agentData.accesToutesLesSections) return sections;
    if (agentData.sections && agentData.sections.length > 0) {
      const agentSectionIds = agentData.sections.map(s => s.id);
      return sections.filter(s => agentSectionIds.includes(s.id));
    }
    return sections;
  }

  render() {
    const { kids } = this.props;
    const sections = this.getVisibleSections();
    const { filterSectionId } = this.state;

    const parsed = queryString.parse(window.location.search);

    let countAbsent = 0;
    let countPresent = 0;
    let countParti = 0;
    let countAttendus = 0;
    let totalNumKids = 0;

    const allKids = this.props.kids.list.kids;
    const kidsToCount = filterSectionId === null
      ? allKids
      : (!_.isEmpty(allKids) ? allKids.filter(kid => kid.sectionId === filterSectionId) : []);

    if (!_.isEmpty(kidsToCount)) {
      totalNumKids = kidsToCount.length;
      kidsToCount.forEach((kid) => {
        if (!_.isEmpty(kid.agenda)) {
          switch (kid.agenda.statutDetails.statut) {
            case "ABSENT":
              countAbsent += 1;
              break;
            case "PRESENT":
              countPresent += 1;
              break;
            case "PARTI":
              countParti += 1;
              break;
            case "ATTENDU":
              countAttendus += 1;
              break;
          }
        }
      });
    }
    const displayHide = { display: "none" };
    const displayShow = { display: "block" };

    const filteredKidIds = this.getFilteredKidIds();

    return (
      <>
        <div className="banner d-flex justify-content-center align-items-center">
          <div className="content">
            <IconBaby />
            <h1>{totalNumKids} enfants inscrits</h1>
          </div>
        </div>
        <section className="bg-lightBlue">
          <HeaderKids
            totalNumKids={totalNumKids}
            countAbsent={countAbsent}
            countPresent={countPresent}
            countAttendus={countAttendus}
            countParti={countParti}
            handleFilterButtons={this.handleFilterButtons}
            sections={sections}
            onSectionFilter={this.handleSectionFilter}
          />
          <ListDisplay
            kids={filteredKidIds}
            kidsById={this.props.kids.byId}
            filterStatus={this.state.filterStatus}
            editEnfant={this.editEnfant}
            openFicheEnfant={this.openFicheEnfant}
            isLoading={this.props.kids.list.loading}
          />
          {!_.isEmpty(kids.list.kids) ? (
            <div className="text-center">
              <a
                href="#"
                className="btn-saisir btn-gradient shadow-none"
                onClick={this.toggleMultiple}
              >
                <AddWhite style={divStyleImg} />
                <span> Saisir</span>
              </a>
            </div>
          ) : (
            ""
          )}
        </section>
        <CrecheLife />
        {this.state.modalMultiple ? (
          <ModalMultiple
            kids={kids.list.kids}
            isOpen={this.state.modalMultiple}
            toggle={this.toggleMultiple}
            handleMultiSubmit={this.handleMultiSubmit}
            kidsIDs={kids.ids}
            lastArrived={kids.list.lastArrived}
          />
        ) : (
          ""
        )}
        {this.state.modalEnfant ? (
          <ModalEnfant
            dataMulti={this.state.dataMulti}
            submitMulti={this.state.submitMulti}
            isOpen={this.state.modalEnfant}
            handleClose={this.handleClose}
            toggle={this.toggleSimple}
            kidItem={this.state.kidItem}
            tabToUpdate={this.state.tabToUpdate}
            isUpdate={this.state.isUpdate}
            tabToView={this.state.tabToView}
            onlyView={this.state.onlyView}
            stopUpdate={this.stopUpdate}
            stopViewing={this.stopViewing}
            modals={this.props.modals}
            idEvent={this.state.idEvent}
            objAbsence={this.state.objAbsence}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

const mapStateToProps = ({
  kids,
  modals,
  errorMsg,
  successMsg,
  loadingMsg,
  ficheEnfant,
  compte,
  gestionCreche,
}) => ({
  kids,
  modals,
  errorMsg,
  successMsg,
  loadingMsg,
  ficheEnfant,
  compte,
  sections: gestionCreche.sections.data,
});

const mapDispatchToProps = {
  getJournee,
  getFilteredKids,
  fetchKids,
  closeSnackBar,
  openSnackBar,
  fetchAgent,
  getSections,
};

const withStore = connect(mapStateToProps, mapDispatchToProps);

export default withStore(Kids);
